import React, { useState, useEffect } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// GLOBAL FUNCTIONS
import { apiFetch, formatDateTime } from 'functions';

// CORE COMPONENTS
import Form from 'core/form/Form';
import Button from 'core/tools/Button';
import Sprite from 'core/tools/Sprite';

// STYLE
import styles from './vehicleManagement.module.scss';

const VehicleManagementItemComments = ({ inventoryId, trackingTypeId, trackMiscId, ...props }) => {

  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState('');

  const getComments = () =>
    apiFetch({
      method: 'GET',
      endpoint: trackMiscId
        ? ENDPOINTS.inventory.miscTask.getTaskComments(inventoryId, trackMiscId)
        : ENDPOINTS.inventory.comments.list,
      params: trackMiscId ? {} : { inventoryId, typeId: trackingTypeId },
      onSuccess: data => {
        const sortComments = trackMiscId ? data.result.reverse() : data.results.reverse()
        setComments(sortComments)
      }
    });

  useEffect(() => {
    getComments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inventoryId]);

  const deleteComment = inventoryCommentId =>
    apiFetch({
      method: 'DELETE',
      endpoint: trackMiscId
        ? ENDPOINTS.inventory.miscTask.deleteTaskComment(inventoryId, trackMiscId, inventoryCommentId)
        : ENDPOINTS.inventory.comments.delete,
      params: trackMiscId ? {} : { inventoryId, inventoryCommentId },
      loadingMessage: 'Deleting comment',
      errorMessage: 'Unable to delete comment.',
      onSuccess: getComments
    });

  const addComment = () => {
    apiFetch({
      method: 'POST',
      endpoint: trackMiscId
        ? ENDPOINTS.inventory.miscTask.addTaskComment(inventoryId, trackMiscId)
        : ENDPOINTS.inventory.comments.add,
      params: trackMiscId
        ? {
            name: comment
          }
        : {
            inventoryId: inventoryId,
            typeId: trackingTypeId,
            name: comment
          },
      loadingMessage: 'Saving comment',
      successMessage: 'Comment saved',
      errorMessage: 'Unable to save comment.',
      onSuccess: () => {
        setComment('');
        getComments();
      },
    });
  };

  // An endpoint is returning nameFull and inventoryCommentId as lowercase so checking for both...
  const Comment = ({ name, nameFull, namefull, dateCreated, inventoryCommentId, inventorycommentid }) => (
    <div className={styles.comment}>
      <div className={styles.body}>
        <div className={styles.message}>{name}</div>
        <div className="ms-auto">
          <Button.Link
            className={styles.deleteButton}
            icon="delete"
            onClick={() => deleteComment(inventoryCommentId || inventorycommentid)}
            square
          />
        </div>
      </div>
      <div className={styles.footer}>
        <span>{nameFull || namefull || ''}</span>
        <span>&nbsp;{formatDateTime(dateCreated)}</span>
      </div>
    </div>
  );
  

  return (
    <>
      <Form.Control
        label={{label: (<>
          <Sprite className="text-primary d-inline-block me-2" use="comments" />
          Comments
        </>)}}
        value={comment}
        placeholder="Type your comment here"
        append={{ use: 'send', onClick: () => addComment() }}
        onChange={e => setComment(e.target.value)}
        useFormik={false}
        fullWidth
        {...props}
      />
      {comments?.map(comment => (
        <Form.PlainText
          as={() => <Comment {...comment} />}
          label=" "
          /*
          label={{label: (<>
            <Sprite className="text-primary d-inline-block me-2" use="clock" />
            {formatDateTime(comment.dateCreated)}
          </>)}}
          */
        />
      ))}
    </>
  );
};

// EXPORT
export default VehicleManagementItemComments;
